function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useState, useRef } from 'react';
import { getChat } from "../../../api/requests/chat";
import { useAuth } from "../../Auth";
import { useMessenger } from "../../Messenger";
import { useChat } from "./useChat";
export const useInfiniteScroll = () => {
  const mounted = useRef(true);

  const _useChat = useChat(),
        setMessages = _useChat.setMessages,
        thereIsMore = _useChat.thereIsMore,
        pages = _useChat.pages;

  const _useAuth = useAuth(),
        user = _useAuth.user;

  const _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        fetching = _useState2[0],
        setFetching = _useState2[1];

  const innerFetching = useRef(false);

  const _useMessenger = useMessenger(),
        selectedChat = _useMessenger.selectedChat;

  useEffect(() => {
    const messagesContainer = document.getElementById('chatMessagesContainer');

    if (messagesContainer) {
      setTimeout(() => messagesContainer.addEventListener('scroll', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (event) {
          const target = event.target;

          if (target.scrollTop === 0) {
            event.target.scrollTop = 1;

            if (!innerFetching.current && thereIsMore.current) {
              setFetching(true);
              innerFetching.current = true;

              const _yield$getChat = yield getChat({
                userId: user?.id,
                withUserId: selectedChat.id,
                page: [...pages.current].reverse()[0] + 1,
                rowsPerPage: 20
              }),
                    totalPages = _yield$getChat.totalPages,
                    newMessages = _yield$getChat.messages;

              if (mounted.current) {
                setMessages(messages => [...newMessages, ...messages.slice(0, 40)]);
                pages.current = pages.current.map(page => page + 1);
                thereIsMore.current = totalPages > [...pages.current].reverse()[0];
              }

              setFetching(false);
              innerFetching.current = false;
            }
          }

          if (target.scrollHeight - target.scrollTop === target.offsetHeight) {
            if (!innerFetching.current && pages.current[0] > 1) {
              setFetching(true);
              innerFetching.current = true;

              const _yield$getChat2 = yield getChat({
                userId: user?.id,
                withUserId: selectedChat.id,
                page: pages.current[0] - 1,
                rowsPerPage: 20
              }),
                    newMessages = _yield$getChat2.messages;

              if (mounted.current) {
                setMessages(messages => [...messages.slice(messages.length - 40), ...newMessages]);
                pages.current = pages.current.map(page => page - 1);
                thereIsMore.current = true;
              }

              setFetching(false);
              innerFetching.current = false;
            }
          }
        });

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()), 1000);
    }

    return () => mounted.current = false;
  }, []);
  return {
    fetching
  };
};